<template>
    <div class="accordion">
            <div class="accordion__container--blur"></div>
            <AccordionTitle v-if="!header" :title="title" :id="id" :open="open" @toggle="onToggle" />
            <AccordionContent :open="open">
                <slot></slot>
            </AccordionContent>
    </div>
</template>
<script>
    import AccordionTitle from "../core/Accordion/TitleAdmin";
    import AccordionContent from "../core/Accordion/ContentAdmin";

    export default {
        props: ["header", "title", "id", "header"],
        name: "AccordionAdmin",
        components: {
            AccordionTitle,
            AccordionContent
        },
        data(){
            return {
                open: false
            }
        },
        methods: {
            onToggle(){
                this.open = !this.open;
            }
        },
        mounted(){
            if(this.header == "off"){
                this.onToggle();
            }
        }
    }
</script>